import { connect } from 'react-redux'

const mapStateToProps = (state) => {
    return {
        coupons: state?.pages.cinestarClub?.coupons ?? [],
        rewards: state?.pages.cinestarClub?.rewards ?? [],
        transactions: state?.pages.cinestarClub?.transactions ?? [],
        userPoints: state?.services?.user?.loyalty_program?.points,
    }
}

const mapDispatchToProps = {}

const hocCinestarClub = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocCinestarClub
